import { reports } from "../reports";
import { tableColumnTypes } from "../../../tableColumnTypes";
import { FormattedMessage } from "react-intl";

export const classTabularModalReport = {
  label: <FormattedMessage id="REPORTCLASS_TEXT" />,
  path: (tenantName) => `/${tenantName}/reports/tabularReport`,

  columns: (navigate) => [
    {
      ID: 1,
      name: <FormattedMessage id="USERGROUP_USERNAME" />,
      fieldName: "UserName",
      value: (row) => row.UserName,
      // sort: true,
      type: tableColumnTypes.STRING,
    },
    {
      ID: 2,
      name: <FormattedMessage id="USERMANAGE_SEARCHSTATUS" />,
      fieldName: "Status",
      value: (row) => row.Status,
      // sort: true,
      type: tableColumnTypes.NUMBER,
    },
    {
      ID: 3,
      name: <FormattedMessage id="REPORT_ASSGNDATE_TXT" />,
      fieldName: "AssignedDate",
      value: (row) => row.AssignedDate,
      // sort: true,
      type: tableColumnTypes.NUMBER,
    },
    {
      ID: 4,
      name: <FormattedMessage id="TRAINING_TYPE" />,
      fieldName: "TrainingType",
      value: (row) => row.TrainingType,
      // sort: true,
    },
    {
      ID: 5,
      name: <FormattedMessage id="REPORT_COMPLETIONDATE_TXT" />,
      fieldName: "DueDate",
      value: (row) => row.DueDate,
      // sort: true,
    },
    {
      ID: 6,
      name: <FormattedMessage id="REPORT_ASSOCIATION_TXT" />,
      fieldName: "Association",
      value: (row) => row.Association,
      // sort: true,
    },
    // {
    //   ID: 7,
    //   name: <FormattedMessage id="REPORT_LIKED_TXT" />,
    //   fieldName: "IsLiked",
    //   value: (row) => row.IsLiked,
    //   sort: true,
    // },
  ],
};
